// extracted by mini-css-extract-plugin
export default {"alert":"AuthAlert_alert__tUFYO","success":"AuthAlert_success__gVhjR","error":"AuthAlert_error__ez+O3"};